import { FormControl, ValidationErrors } from '@angular/forms';

export function PasswordPolicyValidator(
  control: FormControl
): ValidationErrors | null {
  const hasNumber: boolean = /\d/.test(control.value);
  const hasUpper: boolean = /[A-Z]/.test(control.value);
  const hasLower: boolean = /[a-z]/.test(control.value);
  const hasRightLength: boolean =
    8 <= control.value.length && control.value.length <= 64;
  const hasSpecial: boolean = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(
    control.value
  );
  const valid: boolean =
    hasNumber && hasUpper && hasLower && hasRightLength && hasSpecial;
  if (!valid) {
    return { wrongPasswordPolicy: true };
  }
  return null;
}

export function PasswordsDifferencesValidator(
  control: FormControl
): ValidationErrors | null {
  const group: any = control.parent;
  if (group) {
    try {
      return control.value === group.controls.password.value
        ? null
        : { passwordDifferences: true };
    } catch {
      console.error("no 'password' form control");
    }
  }
  return null;
}
